
import React from "react";
import DragDropBox from "../components/DragDropBox";
import DragDropMultipleImagePreview from "../components/DragDropMultipleImagePreview";
import DragAndDropFileUpload from "../components/MultipleFileUpload";
import CircleImageUpload from "../components/CircleImageUpload";
import EditIconFileUpload from "../components/EditIconFileUpload";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import './FileUpload.css';
import { 
    faStar, faStarHalfAlt, faStar as faStarEmpty
} from '@fortawesome/free-solid-svg-icons';


const FileUpload = () =>{

    return(
        <div className="container mt-6">
            <div className="row">
                <div className="col-lg-6">
                    <div className="card">
                        <div className="card-header">
                            <h3>Default File Upload</h3>
                        </div>
                        <div className="card-block">
                            <div className="form-group">
                                <label className="form-label">File Upload</label>
                                <input type="file" className="form-control" />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="card">
                        <div className="card-header">
                            <h3>File Upload</h3>
                        </div>
                        <div className="card-block">
                            <DragDropBox />
                        </div>
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="card">
                        <div className="card-header">
                            <h3>File Upload</h3>
                        </div>
                        <div className="card-block">
                            <DragDropMultipleImagePreview />
                        </div>
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="card">
                        <div className="card-header">
                            <h3>File Upload</h3>
                        </div>
                        <div className="card-block">
                            <DragAndDropFileUpload />
                        </div>
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="card">
                        <div className="card-header">
                            <h3>Rating</h3>
                        </div>
                        <div className="card-block">
                            <div className="rating">
                                <FontAwesomeIcon icon={faStar} className="" />
                                <FontAwesomeIcon icon={faStar} className="" />
                                <FontAwesomeIcon icon={faStar} className="" />
                                <FontAwesomeIcon icon={faStar} className="" />
                                <FontAwesomeIcon icon={faStarHalfAlt} className="" />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="card">
                        <div className="card-header">
                            <h3>Circle Image Upload</h3>
                        </div>
                        <div className="card-block">
                            <CircleImageUpload />
                        </div>
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="card">
                        <div className="card-header">
                            <h3>Edit Icon File Upload</h3>
                        </div>
                        <div className="card-block">
                            <EditIconFileUpload />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}


export default FileUpload;